import React from 'react';

const Divider = () => (
  <div className={'mdc-divider'}
  />);

export default Divider;
